import { createSlice } from "@reduxjs/toolkit";
import { CATEGORIES } from "../../helpers";

const budgetsSlice = createSlice({
    name: 'budgets',
    initialState: Object.fromEntries(CATEGORIES.map((name) => [name, 0])),
    reducers: {
        changeBudget: (state, action) => {
            state[action.payload.category] = action.payload.amount;
        }
    }
})

export const {changeBudget} = budgetsSlice.actions;
export default budgetsSlice.reducer;